import { render, staticRenderFns } from "./listing_detail.vue?vue&type=template&id=0b4d210f&scoped=true"
import script from "./listing_detail.vue?vue&type=script&lang=js"
export * from "./listing_detail.vue?vue&type=script&lang=js"
import style0 from "./listing_detail.vue?vue&type=style&index=0&id=0b4d210f&prod&scoped=true&lang=css"
import style1 from "./listing_detail.vue?vue&type=style&index=1&id=0b4d210f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d210f",
  null
  
)

export default component.exports